import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setupRoutePrefetching, setupLazyPrefetching } from '@/utils/resourceHints';

/**
 * Component that sets up route prefetching for better navigation performance
 */
export function RoutePrefetcher() {
  const location = useLocation();
  
  useEffect(() => {
    // Setup prefetching when location changes
    setupRoutePrefetching();
    setupLazyPrefetching();
    
    // Re-setup when navigating to handle new links
  }, [location.pathname]);
  
  return null;
}